// extracted by mini-css-extract-plugin
export default {"toastBox":"mention_toastBox__UbwNq","toastNameBox":"mention_toastNameBox__K2hng","toastName":"mention_toastName__yRFpL"};